import { DRYBULK_CARGO_OPS_LANG_BASE, OPERATION_STATUSES } from "../constants";

/**
 * DBCO-0031 (D2) - the label of an operation status, exactly as the server returned it: a known name is
 * translated, an unknown one shows its raw value (the server may add a status before this list does), and
 * a missing one shows a dash. Used by the grid and the operation page header.
 */
export const statusLabel = (
  t: (key: string) => string,
  status: string | null | undefined,
): string => {
  if (status === null || status === undefined) {
    return "-";
  }
  return OPERATION_STATUSES.includes(status)
    ? t(`${DRYBULK_CARGO_OPS_LANG_BASE}.status.${status}`)
    : status;
};
